import { getSupportedCategoryCountry } from 'src/app/utils/getCategoryCountry';
import { useGetSuggestedCategoriesLazyQuery } from 'src/graphql/generated';

export const useCategoryLazyQuery = (jobTitle: string, jobLocation: string) => {
  const [getSuggestedCategoriesQuery] = useGetSuggestedCategoriesLazyQuery({
    variables: {
      jobTitle,
      country: getSupportedCategoryCountry(jobLocation),
    },
    fetchPolicy: 'cache-first',
  });

  return [getSuggestedCategoriesQuery];
};
